import { render } from "./WordCloud.vue?vue&type=template&id=b210cffa&ts=true"
import script from "./WordCloud.vue?vue&type=script&lang=ts"
export * from "./WordCloud.vue?vue&type=script&lang=ts"

import "./WordCloud.vue?vue&type=style&index=0&id=b210cffa&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__